<div
	class="tags-data-cell"
	[class.expanded]="!tagsCollapsed"
	[ngStyle]="{ minWidth: minWidth }"
>
	@if (tagsCollapsed) {
		@for (tag of tags | slice: 0 : initSize; track tag) {
			<div class="tag-container">
				<span
					class="tag"
					[ngStyle]="{ maxWidth: textMaxWidth }"
					[matTooltip]="tag?.contentType || tag?.fullName || tag?.name"
					matTooltipPosition="below"
					>{{ tag?.name }}</span
				>
			</div>
		}
		@if (tags.length > initSize) {
			<div class="tag-container" (click)="toggleTags(); $event.stopPropagation()">
				<span class="tag show-more"> +{{ tags.length - initSize }} </span>
			</div>
		}
	} @else {
		@for (tag of tags; track tag) {
			<div class="tag-container">
				<span
					class="tag"
					[ngStyle]="{ maxWidth: textMaxWidth }"
					[matTooltip]="tag?.contentType || tag?.name"
					matTooltipPosition="below"
					>{{ tag?.name }}</span
				>
			</div>
		}
		<div class="tag-container" (click)="toggleTags(); $event.stopPropagation()">
			<span class="tag show-less">{{ 'show_less' | translate }}</span>
		</div>
	}

	<ng-content></ng-content>
</div>
